import { PALETTE } from '../../common/styles/palette';

export const styles = (theme: any) => {
    return {
        SearchContainer: {
            display: 'flex',
            alignItems: 'center',
        },
        searchButtons: {
            // width: '100%',
            paddingLeft: '10px',
            display: 'flex'
        },
        searchButton: {
            marginLeft: '10px',
            marginRight: '10px',
        },
        SearchSection: {
            display: 'flex',
            alignItems: 'center',
            padding: "0px 2px",
            justifyContent: 'flex-start',
            flexGrow: 4,
        },
        SmallSearchSection: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexBasis: "100%",
        },
        GroupButtonSelected: {
            backgroundColor: PALETTE.UI.Buttons.HoveredBackground,
            color: 'white',
            "&:hover": {
                color: "#333",
                backgroundColor: "#fcdbbb"
            }
        },
        GroupButtonNotSelected: {
            backgroundColor: '#CCCCCC',
            color: '#333',
            "&:hover": {
                color: "#333",
                backgroundColor: "#fcdbbb"
            }
        },
        detailSample: {
            display: 'flex',
            padding: '5px',
            alignContent: 'center',
            margin: '10px'
        },
        detailSampleText: {
            paddingLeft: '20px',
        },
        textColorRadioGroup: {
            paddingLeft: '10px',
            border: '1px solid black',
            width: 'fit-content'
        },
        colorSection: {
            marginTop: '20px'
        },
        colorSectionItem: {
            marginTop: '10px'
        },
        detailButtonsContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            padding: '0px 10px 10px 0px'
        },
        contactCount: {
            display: 'flex',
            alignItems: 'center'
        },
        followersHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: '10px'
        },
        tableRow: {
            padding: "5px 0px",
            "&:hover": {
                backgroundColor: "#ececec",
            }
        },
        tableHeader: {
            backgroundColor: PALETTE.UI.TablesHeader.BackgroundColor,
            display: 'flex',
            alignItems: 'center',
            padding: "0px",
            borderRadius: "5px 5px 0 0",
            // paddingTop: '2px',
            // paddingBottom: '2px',
            // paddingLeft: '10px',
            // paddingRight: '10px',
        },
        table: {
            display: 'flex',
            alignItems: 'center',
            // paddingTop: '2px',
            // paddingBottom: '2px',
            // paddingLeft: '10px',
            // paddingRight: '10px',
        },
        tableHeaderCell: {
            display: 'flex',
            padding: "2px 5px",
            alignItems: 'center',
            "&.first": {
                borderRadius: "5px 0 0 0",
            },
            "&.last": {
                borderRadius: "0 5px 0 0",
            },
            "&.sort": {
                cursor: "pointer",
                "&:hover": {
                    backgroundColor: "#fcdbbb",
                    // color: "white"
                }
            }
        },
        detailHeaderText: {
            paddingLeft: '0px'
        },
        tagIcon: {
            minWidth: '0px',
            paddingRight: '10px'
        },
        reservationFreeSlotCell: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "0.5px solid #b3b3b3",
            cursor: "pointer",
            position: "relative",
            "&:hover": {
                backgroundColor: PALETTE.Secondary,
                color: "#FFF",
            },
            "&.disabled": {
                "&:hover": {
                    backgroundColor: "#FFF",
                    zIndex: "unset"
                }
            }
        },
        reservationSlotTimeContainer: {
            position: "absolute",
            top: "2px",
            left: "2px",
        },
        reservationFullSlotCell: {
            backgroundColor: "#ff3333",
            "&:hover": {
                backgroundColor: "#FF8080",
                zIndex: 100
            },
            "&.disabled": {
                "&:hover": {
                    backgroundColor: "#FFF",
                    zIndex: "unset"
                }
            }
        },
        reservationNotAvailableSlotCell: {
            border: "1px solid #b3b3b3",
            backgroundColor: "grey",
        },
        reservationPaperContainer: {
            minWidth: "800px"
        },
        reservationCalendarContainer: {
            padding: "5px"
        },
        reservationCalendarBodyContainer: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            margin: "5px 10px"
        },
        reservationHourColumn: {
            width: "60px",
            flexDirection: "row",
            position: "relative",
        },
        reservationHourLine: {
            width: "100%",
            margin: "0px",
            borderColor: "#b3b3b3",
        }, reservationHourContainer: {
            position: "absolute",
            width: "100%"
        },
        reservationDayColumn: {
            display: "flex",
            flexDirection: "column",
            flexGrow: "4"
        },
        reservationDayHeader: {
            display: "flex",
            flexDirection: "column",
            height: "100px"
        },
        reservationDayNumber: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "50px",
            height: "50px",
            borderRadius: "50%"
        },
        reservationDayToday: {
            backgroundColor: PALETTE.Primary,
            color: "#FFF"
        },
        reservationDayNumberTypography: {
            fontSize: "30px"
        },
        reservationDayNameTypography: {
            fontSize: "20px"
        },
        reservationDayRows: {
            display: "flex",
            justifyContent: "center",
        },
        reservationSlotDetailDialogContent: {
            minWidth: '550px',
            justifyContent: 'center',
            flexDirection: "column",
            alignItems: 'center',
            display: 'flex',
            overflowY: "visible",
            marginTop: '0px'
        },
        reservationSlotDetailDialogActions: {
            justifyContent: 'flex-end',
            padding: '10px'
        },
        tabsFullWith: {
            width: "100%"
        },
        ReservationSlotInfoContainer: {
            margin: "10px",
        },
        ReservationDialog: {
            overflowY: "visible",
            minWidth: "600px",
        },
        SuccesfullResponse: {
            color: "green"
        },
        ErrorResponse: {
            color: "red"
        },
        Typography: {
            fontSize: "1.1rem"
        },
        deleteConfirmButton: {
            marginRight: "5px"
        }

    }
}